// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Photo Gallery Styles */
.photo-gallery {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 20px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

/* Force visibility for debugging */
.photo-gallery * {
  visibility: visible !important;
  opacity: 1 !important;
}

/* Force text visibility */ 
.photo-gallery input, select, button, span, p, h1, h2, h3, h4, h5, h6 {
  color: inherit ;
  visibility: visible !important;
  opacity: 1 !important;
}

/* Ensure all form elements have visible text */
.search-box input,
.filter-groups select,
.view-btn,
.action-btns {
  color: #2d3748 !important;
  visibility: visible !important;
  opacity: 1 !important;
}

/* Ensure all text is visible */
.media-name,
.media-meta,
.media-details,
.barcode {
  color: #2d3748 !important;
  opacity: 1 !important;
  visibility: visible !important;
}

.media-meta {
  color: #4a5568 !important;
}

.media-details {
  color: #718096 !important;
}

/* Header */
.gallery-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  padding: 20px 0;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 20px;
}

.back-link {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #0f172a;
  text-decoration: none;
  font-weight: 600;
  padding: 8px 16px;
  border-radius: 8px;
  background: rgba(102, 126, 234, 0.1);
  transition: all 0.3s ease;
}

.back-link:hover {
  background: rgba(102, 126, 234, 0.2);
  transform: translateX(-2px);
}

.page-title {
  display: flex;
  align-items: center;
  gap: 12px;
}

.title-icon {
  font-size: 1.5rem;
  color: #0f172a;
}

.page-title h1 {
  font-size: 2rem;
  font-weight: 700;
  color: #2d3748;
  margin: 0;
}

.header-actions {
  display: flex;
  gap: 15px;
}

.upload-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(135deg, #0f172a 0%, #2563eb 100%);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
}
/* =======================================\`\`====================================== */
.filter-groups select {
  padding: 10px 35px !important;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background: white;
  color: #2d3748;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.3s 
ease;
  min-width: 100%;
}
/* =======================================\`\`====================================== */

.upload-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.4);
}

/* Gallery Controls */
.gallery-controls {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 30px;
}

.search-section {
  display: flex;
  justify-content: center;
}

.search-box {
  position: relative;
  width: 100%;
  max-width: 500px;
}

.search-icon {
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: #a0aec0 !important;
  font-size: 1rem;
  visibility: visible !important;
  opacity: 1 !important;
}

.search-box input {
  width: 100%;
  padding: 12px 15px 12px 45px;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  font-size: 1rem;
  background: white;
  color: #2d3748 !important;
  transition: all 0.3s ease;
}

.search-box input::placeholder {
  color: #a0aec0 !important;
  opacity: 1 !important;
}

.search-box input:focus {
  outline: none;
  border-color: #0f172a;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.filters-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
}

.filter-groups {
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
}

.filter-icon {
  /* color: rgba(255, 255, 255, 0.8) !important; */
  font-size: 1rem;
  visibility: visible !important;
  opacity: 1 !important;
}


.filter-groups select option {
  color: #2d3748 !important;
  background: white !important;
  padding: 8px;
}

.filter-groups select:focus {
  outline: none;
  border-color: rgba(255, 255, 255, 0.5);
  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.2);
  background: rgba(255, 255, 255, 0.2);
}

.view-controls {
  display: flex;
  gap: 5px;
  background: white;
  border-radius: 8px;
  padding: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.view-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: #a0aec0 !important;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 1.1rem;
}

.view-btn.active {
  background: #0f172a;
  /* color: white !important; */
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
}

.view-btn:hover:not(.active) {
  background: #f7fafc;
  color: #4a5568 !important;
}

/* Selection Controls */
.selection-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: white;
  padding: 15px 20px;
  border-radius: 12px;
  margin-bottom: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid #e2e8f0;
}

.selection-info {
  display: flex;
  align-items: center;
  gap: 15px;
}

.selection-info span {
  font-weight: 600;
  color: #2d3748;
}

.select-all-btn {
  background: #f7fafc;
  color: #4a5568;
  border: 1px solid #e2e8f0;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.3s ease;
}

.select-all-btn:hover {
  background: #edf2f7;
  color: #2d3748;
}

.selection-actions {
  display: flex;
  gap: 12px;
  flex-wrap: nowrap;
  align-items: center;
}

.action-btns {
  width: 40%;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  border: none;
  border-radius: 10px;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  min-height: 44px;
  white-space: nowrap;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.action-btns.download {
  background: #c6f6d5;
  color: #22543d;
  border: 1px solid #9ae6b4;
}

.action-btns.share {
  background: #e6fffa;
  color: #234e52;
  border: 1px solid #b2f5ea;
}

.action-btns.barcode {
  background: #fef5e7;
  color: #c05621;
  border: 1px solid #f6e05e;
  /* min-width: 100%; */
}

.action-btns.delete {
  background: #fed7d7;
  color: #742a2a;
  border: 1px solid #feb2b2;
}

.action-btns:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* Media Container */
.media-container {
  display: grid;
  gap: 20px;
}

.media-container.grid {
  grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
}

.media-container.list {
  grid-template-columns: 1fr;
}

/* Media Item */
.media-item {
  background: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  cursor: pointer;
  border: 2px solid transparent;
  position: relative;
}

.media-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

.media-item.selected {
  border-color: #0f172a;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.2);
}

.media-preview {
  position: relative;
  aspect-ratio: 16/9;
  overflow: hidden;
  background: linear-gradient(135deg, #f7fafc 0%, #edf2f7 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Placeholder for missing images */
.media-preview::before {
  content: "📷";
  font-size: 2.5rem;
  color: #a0aec0;
  position: absolute;
  z-index: 1;
}

.media-preview img,
.media-preview video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  background: #f7fafc;
  position: relative;
  z-index: 2;
}

/* Hide placeholder when image loads */
.media-preview img[src]:not([src=""]),
.media-preview video[src]:not([src=""]) {
  z-index: 2;
}

.media-preview img[src]:not([src=""]) ~ .media-preview::before,
.media-preview video[src]:not([src=""]) ~ .media-preview::before {
  display: none;
}

/* Fallback for missing images */
.media-preview img[src=""],
.media-preview img:not([src]) {
  background: linear-gradient(135deg, #0f172a 0%, #2563eb 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.media-preview img[src=""]::before,
.media-preview img:not([src])::before {
  content: "📷";
  font-size: 2rem;
  color: white;
}

.video-preview {
  position: relative;
  width: 100%;
  height: 100%;
}

.video-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.7);
  color: white;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
}

.media-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: all 0.3s ease;
}

.media-item:hover .media-overlay {
  opacity: 1;
}

.overlay-actions {
  display: flex;
  gap: 15px;
}

.overlay-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 45px;
  height: 45px;
  border: none;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.9);
  color: #2d3748;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 1.1rem;
}

.overlay-btn:hover {
  background: white;
  transform: scale(1.1);
}

.selection-indicator {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 30px;
  height: 30px;
  background: #0f172a;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.9rem;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
}

.media-info {
  padding: 20px;
  background: white;
}

.media-name {
  font-size: 1.1rem;
  font-weight: 700;
  color: #1a202c !important;
  margin: 0 0 8px 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.3;
}

.media-meta {
  color: #4a5568 !important;
  margin: 0 0 10px 0;
  font-size: 0.95rem;
  font-weight: 500;
  line-height: 1.4;
}

.media-details {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  font-size: 0.85rem;
  color: #718096 !important;
  font-weight: 500;
}

.barcode {
  background: #e6fffa;
  color: #234e52 !important;
  padding: 4px 8px;
  border-radius: 6px;
  font-weight: 700;
  font-size: 0.8rem;
  border: 1px solid #b2f5ea;
}

.media-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.tag {
  background: #e6fffa;
  color: #234e52;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 500;
}

/* List View Specific */
.media-container.list .media-item {
  display: flex;
  align-items: center;
  padding: 15px;
}

.media-container.list .media-preview {
  width: 160px;
  height: 110px;
  flex-shrink: 0;
  margin-right: 15px;
}

.media-container.list .media-info {
  flex: 1 1;
  padding: 0;
}

.media-container.list .media-name {
  white-space: normal;
  margin-bottom: 8px;
}

/* Empty State */
.empty-state {
  text-align: center;
  padding: 60px 20px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  grid-column: 1 / -1;
}

.empty-icon {
  font-size: 4rem;
  color: #a0aec0;
  margin-bottom: 20px;
}

.empty-state h3 {
  font-size: 1.5rem;
  color: #2d3748;
  margin: 0 0 10px 0;
}

.empty-state p {
  color: #4a5568;
  margin: 0 0 30px 0;
}

.upload-first-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(135deg, #c13183 0%, #4f46e5 100%);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.upload-first-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.4);
}

/* Loading State */
.gallery-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  color: #4a5568;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #e2e8f0;
  border-top: 4px solid #0f172a;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Upload Modal */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.modal-content {
  background: white;
  border-radius: 16px;
  width: 100%;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 25px 30px;
  border-bottom: 1px solid #e2e8f0;
}

.modal-header h2 {
  font-size: 1.5rem;
  font-weight: 700;
  color: #2d3748;
  margin: 0;
}

.close-btn {
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #a0aec0;
  cursor: pointer;
  padding: 5px;
  border-radius: 6px;
  transition: all 0.3s ease;
}

.close-btn:hover {
  background: #f7fafc;
  color: #4a5568;
}

.upload-area {
  padding: 30px;
}

.upload-dropzone {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  border: 2px dashed #cbd5e0;
  border-radius: 12px;
  background: #f7fafc;
  cursor: pointer;
  transition: all 0.3s ease;
  text-align: center;
}

.upload-dropzone:hover {
  border-color: #0f172a;
  background: #edf2f7;
}

.upload-icon {
  font-size: 3rem;
  color: #a0aec0;
  margin-bottom: 20px;
}

.upload-dropzone h3 {
  font-size: 1.2rem;
  color: #2d3748;
  margin: 0 0 10px 0;
}

.upload-dropzone p {
  color: #4a5568;
  margin: 0;
}

.upload-progress {
  margin-top: 20px;
}

.progress-bar {
  width: 100%;
  height: 8px;
  background: #e2e8f0;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 10px;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(135deg, #0f172a 0%, #2563eb 100%);
  transition: width 0.3s ease;
}

.upload-options {
  padding: 0 30px 30px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.option-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.option-group label {
  font-weight: 600;
  color: #2d3748;
  font-size: 0.9rem;
}

.option-group select {
  padding: 10px 15px;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 1rem;
  transition: all 0.3s ease;
}

.option-group select:focus {
  outline: none;
  border-color: #0f172a;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

/* Responsive Design */
@media (max-width: 768px) {
  .photo-gallery {
    padding: 15px;
  }
  
  .gallery-header {
    flex-direction: column;
    gap: 15px;
    align-items: stretch;
  }
  
  .header-left {
    flex-direction: column;
    gap: 15px;
    align-items: stretch;
  }
  
  .page-title h1 {
    font-size: 1.5rem;
  }
  
  .filters-section {
    flex-direction: column;
    gap: 15px;
  }
  
  .filter-groups {
    width: 100%;
  }
  
  .filter-groups select {
    width: 100%;
  }
  
  .selection-controls {
    flex-direction: column;
    gap: 15px;
    align-items: stretch;
  }
  
  .selection-actions {
    justify-content: center;
    flex-wrap: wrap;
    gap: 8px;
  }
  
  .action-btns {
    padding: 10px 16px;
    font-size: 0.9rem;
    min-height: 40px;
    width: 100%;
  }
  
  .action-btns.barcode {
    min-width: 100px;
  }
  
  .media-container.grid {
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  }
  
  .upload-options {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 480px) {
  .photo-gallery {
    padding: 10px;
  }
  
  .media-container.grid {
    grid-template-columns: 1fr;
  }
  
  .modal-content {
    margin: 10px;
  }
  
  .modal-header,
  .upload-area {
    padding: 20px;
  }
}

/* === Enhanced Gallery Card UI (non-breaking overrides) === */
.media-container.grid .media-item {
  border-radius: 16px;
  overflow: hidden;
  background: #fff;
  border: 1px solid rgba(17, 24, 39, 0.06);
  box-shadow: 0 8px 24px rgba(17, 24, 39, 0.06);
  transition: transform 0.25s ease, box-shadow 0.25s ease;
  display: block; /* Ensure vertical stacking in grid */
}

.media-container.grid .media-item:hover {
  transform: translateY(-3px);
  box-shadow: 0 14px 36px rgba(17, 24, 39, 0.12);
}

.media-container.grid .media-preview {
  position: relative;
  background: #f3f4f6;
  /* Bigger preview for clarity in grid */
  aspect-ratio: 16 / 10;
  width: 50%;
  height: 50%;
  /* min-height: 200px; Ensure visibly large preview */
}

.media-container.grid .media-preview img,
.media-container.grid .media-preview video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center center;
  display: block;
  transition: transform 0.35s ease;
}

.media-container.grid .media-item:hover .media-preview img,
.media-container.grid .media-item:hover .media-preview video {
  transform: scale(1.03);
}

.media-container.grid .media-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(to top, rgba(0,0,0,0.45), rgba(0,0,0,0.05));
  opacity: 0;
  transition: opacity 0.25s ease;
}

.media-container.grid .media-item:hover .media-overlay {
  opacity: 1;
}

/* Hide overlay buttons in grid minimal mode */
.media-container.grid .media-overlay.hidden-grid {
  opacity: 0 !important;
  pointer-events: none;
}

/* Name overlay for minimal image-first grid */
.media-container.grid .name-overlay {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 10px 12px;
  background: linear-gradient(to top, rgba(0,0,0,0.65), rgba(0,0,0,0.0));
  color: #ffffff;
  font-weight: 700;
  font-size: 14px;
  text-shadow: 0 1px 2px rgba(0,0,0,0.35);
  z-index: 2;
  display: -webkit-box;
  line-clamp: 1;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.media-container.grid .overlay-actions {
  position: absolute;
  bottom: 10px;
  right: 10px;
  display: flex;
  gap: 8px;
}

.media-container.grid .overlay-btn {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.9);
  color: #111827;
  border: 1px solid rgba(0,0,0,0.06);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.15s ease, background 0.2s ease;
}

.media-container.grid .overlay-btn:hover {
  transform: translateY(-1px);
  background: #ffffff;
}

.media-container.grid .media-info {
  padding: 12px 14px 14px 14px;
}

/* Persistent media actions bar */
.media-actions {
  display: flex;
  gap: 8px;
  padding: 10px 12px 0 12px;
  background: #ffffff;
  flex-wrap: wrap;
}

.media-action-btn {
  /* width: 50%; */
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 12px;
  border: 1px solid rgba(17, 24, 39, 0.08);
  background: #f9fafb;
  color: #111827;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.15s ease, color 0.2s ease;
}

.media-action-btn .label {
  display: none;
}

@media (min-width: 520px) {
  .media-action-btn .label {
    display: inline;
  }
}

.media-action-btn:hover {
  background: #ffffff;
  transform: translateY(-1px);
}

.media-action-btn.view {
  border-color: rgba(59, 130, 246, 0.25);
}

.media-action-btn.edit {
  border-color: rgba(16, 185, 129, 0.25);
}

.media-action-btn.barcode {
  border-color: rgba(234, 179, 8, 0.3);
}

.media-container.grid .media-name {
  font-weight: 700;
  color: #111827;
  margin: 0 0 4px 0;
  display: -webkit-box;
  line-clamp: 1;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.media-container.grid .media-meta {
  color: #6b7280;
  font-size: 12px;
  margin: 0 0 8px 0;
  display: -webkit-box;
  line-clamp: 1;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.media-container.grid .media-details {
  display: flex;
  gap: 10px;
  align-items: center;
  color: #6b7280;
  font-size: 12px;
}

.media-container.grid .barcode {
  background: #eef2ff;
  color: #3730a3;
  border-radius: 8px;
  padding: 2px 6px;
  font-size: 11px;
}

/* Selection indicator polish */
.media-container.grid .selection-indicator {
  position: absolute;
  top: 10px;
  left: 10px;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: #2563eb;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.4);
}

/* Persistent caption under each grid card */
.media-container.grid .media-caption {
  padding: 10px 12px 12px 12px;
  background: #ffffff;
  border-top: 1px solid rgba(17, 24, 39, 0.06);
  font-weight: 700;
  color: #111827;
  font-size: 14px;
  line-height: 1.3;
  display: -webkit-box;
  line-clamp: 1;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./src/pages/photo-studio/PhotoGallery.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,aAAa;EACb,8EAA8E;AAChF;;AAEA,mCAAmC;AACnC;EACE,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA,0BAA0B;AAC1B;EACE,eAAe;EACf,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA,+CAA+C;AAC/C;;;;EAIE,yBAAyB;EACzB,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA,+BAA+B;AAC/B;;;;EAIE,yBAAyB;EACzB,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,+CAA+C;AACjD;AACA,oFAAoF;AACpF;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf;IACE;EACF,eAAe;AACjB;AACA,oFAAoF;;AAEpF;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,yBAAyB;EACzB,eAAe;EACf,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gDAAgD;EAChD,eAAe;EACf,8BAA8B;EAC9B,qBAAqB;AACvB;;;AAGA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,8CAA8C;EAC9C,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,eAAe;AACf;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,yBAAyB;EACzB,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,6DAA6D;EAC7D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA,sCAAsC;AACtC;;EAEE,UAAU;AACZ;;AAEA;;EAEE,aAAa;AACf;;AAEA,gCAAgC;AAChC;;EAEE,6DAA6D;EAC7D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,8BAA8B;EAC9B,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,6DAA6D;EAC7D,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,uBAAuB;IACvB,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,4DAA4D;EAC9D;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,YAAY;EACd;;EAEA;;IAEE,aAAa;EACf;AACF;;AAEA,8DAA8D;AAC9D;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,wCAAwC;EACxC,6CAA6C;EAC7C,uDAAuD;EACvD,cAAc,EAAE,qCAAqC;AACvD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,uCAAuC;EACvC,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,oDAAoD;AACtD;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,8BAA8B;EAC9B,cAAc;EACd,gCAAgC;AAClC;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,uEAAuE;EACvE,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA,8CAA8C;AAC9C;EACE,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA,8CAA8C;AAC9C;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,sEAAsE;EACtE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,uCAAuC;EACvC,UAAU;EACV,oBAAoB;EACpB,aAAa;EACb,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,cAAc;EACd,kCAAkC;EAClC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sDAAsD;AACxD;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,wCAAwC;EACxC,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,uEAAuE;AACzE;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,aAAa;EACb,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,aAAa;EACb,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4CAA4C;AAC9C;;AAEA,4CAA4C;AAC5C;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,4CAA4C;EAC5C,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;EACb,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB","sourcesContent":["/* Photo Gallery Styles */\n.photo-gallery {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);\n  padding: 20px;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n}\n\n/* Force visibility for debugging */\n.photo-gallery * {\n  visibility: visible !important;\n  opacity: 1 !important;\n}\n\n/* Force text visibility */ \n.photo-gallery input, select, button, span, p, h1, h2, h3, h4, h5, h6 {\n  color: inherit ;\n  visibility: visible !important;\n  opacity: 1 !important;\n}\n\n/* Ensure all form elements have visible text */\n.search-box input,\n.filter-groups select,\n.view-btn,\n.action-btns {\n  color: #2d3748 !important;\n  visibility: visible !important;\n  opacity: 1 !important;\n}\n\n/* Ensure all text is visible */\n.media-name,\n.media-meta,\n.media-details,\n.barcode {\n  color: #2d3748 !important;\n  opacity: 1 !important;\n  visibility: visible !important;\n}\n\n.media-meta {\n  color: #4a5568 !important;\n}\n\n.media-details {\n  color: #718096 !important;\n}\n\n/* Header */\n.gallery-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 30px;\n  padding: 20px 0;\n}\n\n.header-left {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n.back-link {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #0f172a;\n  text-decoration: none;\n  font-weight: 600;\n  padding: 8px 16px;\n  border-radius: 8px;\n  background: rgba(102, 126, 234, 0.1);\n  transition: all 0.3s ease;\n}\n\n.back-link:hover {\n  background: rgba(102, 126, 234, 0.2);\n  transform: translateX(-2px);\n}\n\n.page-title {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.title-icon {\n  font-size: 1.5rem;\n  color: #0f172a;\n}\n\n.page-title h1 {\n  font-size: 2rem;\n  font-weight: 700;\n  color: #2d3748;\n  margin: 0;\n}\n\n.header-actions {\n  display: flex;\n  gap: 15px;\n}\n\n.upload-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: linear-gradient(135deg, #0f172a 0%, #2563eb 100%);\n  color: white;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);\n}\n/* =======================================``====================================== */\n.filter-groups select {\n  padding: 10px 35px !important;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  background: white;\n  color: #2d3748;\n  font-size: 0.9rem;\n  cursor: pointer;\n  transition: all 0.3s \nease;\n  min-width: 100%;\n}\n/* =======================================``====================================== */\n\n.upload-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.4);\n}\n\n/* Gallery Controls */\n.gallery-controls {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  margin-bottom: 30px;\n}\n\n.search-section {\n  display: flex;\n  justify-content: center;\n}\n\n.search-box {\n  position: relative;\n  width: 100%;\n  max-width: 500px;\n}\n\n.search-icon {\n  position: absolute;\n  left: 15px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #a0aec0 !important;\n  font-size: 1rem;\n  visibility: visible !important;\n  opacity: 1 !important;\n}\n\n.search-box input {\n  width: 100%;\n  padding: 12px 15px 12px 45px;\n  border: 2px solid #e2e8f0;\n  border-radius: 12px;\n  font-size: 1rem;\n  background: white;\n  color: #2d3748 !important;\n  transition: all 0.3s ease;\n}\n\n.search-box input::placeholder {\n  color: #a0aec0 !important;\n  opacity: 1 !important;\n}\n\n.search-box input:focus {\n  outline: none;\n  border-color: #0f172a;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.filters-section {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 20px;\n  flex-wrap: wrap;\n}\n\n.filter-groups {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.filter-icon {\n  /* color: rgba(255, 255, 255, 0.8) !important; */\n  font-size: 1rem;\n  visibility: visible !important;\n  opacity: 1 !important;\n}\n\n\n.filter-groups select option {\n  color: #2d3748 !important;\n  background: white !important;\n  padding: 8px;\n}\n\n.filter-groups select:focus {\n  outline: none;\n  border-color: rgba(255, 255, 255, 0.5);\n  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.2);\n  background: rgba(255, 255, 255, 0.2);\n}\n\n.view-controls {\n  display: flex;\n  gap: 5px;\n  background: white;\n  border-radius: 8px;\n  padding: 4px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.view-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border: none;\n  border-radius: 6px;\n  background: transparent;\n  color: #a0aec0 !important;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 1.1rem;\n}\n\n.view-btn.active {\n  background: #0f172a;\n  /* color: white !important; */\n  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);\n}\n\n.view-btn:hover:not(.active) {\n  background: #f7fafc;\n  color: #4a5568 !important;\n}\n\n/* Selection Controls */\n.selection-controls {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: white;\n  padding: 15px 20px;\n  border-radius: 12px;\n  margin-bottom: 20px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  border: 1px solid #e2e8f0;\n}\n\n.selection-info {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n.selection-info span {\n  font-weight: 600;\n  color: #2d3748;\n}\n\n.select-all-btn {\n  background: #f7fafc;\n  color: #4a5568;\n  border: 1px solid #e2e8f0;\n  padding: 6px 12px;\n  border-radius: 6px;\n  font-size: 0.9rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.select-all-btn:hover {\n  background: #edf2f7;\n  color: #2d3748;\n}\n\n.selection-actions {\n  display: flex;\n  gap: 12px;\n  flex-wrap: nowrap;\n  align-items: center;\n}\n\n.action-btns {\n  width: 40%;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 20px;\n  border: none;\n  border-radius: 10px;\n  font-size: 0.95rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  min-height: 44px;\n  white-space: nowrap;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.action-btns.download {\n  background: #c6f6d5;\n  color: #22543d;\n  border: 1px solid #9ae6b4;\n}\n\n.action-btns.share {\n  background: #e6fffa;\n  color: #234e52;\n  border: 1px solid #b2f5ea;\n}\n\n.action-btns.barcode {\n  background: #fef5e7;\n  color: #c05621;\n  border: 1px solid #f6e05e;\n  /* min-width: 100%; */\n}\n\n.action-btns.delete {\n  background: #fed7d7;\n  color: #742a2a;\n  border: 1px solid #feb2b2;\n}\n\n.action-btns:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n/* Media Container */\n.media-container {\n  display: grid;\n  gap: 20px;\n}\n\n.media-container.grid {\n  grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));\n}\n\n.media-container.list {\n  grid-template-columns: 1fr;\n}\n\n/* Media Item */\n.media-item {\n  background: white;\n  border-radius: 16px;\n  overflow: hidden;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n  transition: all 0.3s ease;\n  cursor: pointer;\n  border: 2px solid transparent;\n  position: relative;\n}\n\n.media-item:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);\n}\n\n.media-item.selected {\n  border-color: #0f172a;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.2);\n}\n\n.media-preview {\n  position: relative;\n  aspect-ratio: 16/9;\n  overflow: hidden;\n  background: linear-gradient(135deg, #f7fafc 0%, #edf2f7 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Placeholder for missing images */\n.media-preview::before {\n  content: \"📷\";\n  font-size: 2.5rem;\n  color: #a0aec0;\n  position: absolute;\n  z-index: 1;\n}\n\n.media-preview img,\n.media-preview video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  background: #f7fafc;\n  position: relative;\n  z-index: 2;\n}\n\n/* Hide placeholder when image loads */\n.media-preview img[src]:not([src=\"\"]),\n.media-preview video[src]:not([src=\"\"]) {\n  z-index: 2;\n}\n\n.media-preview img[src]:not([src=\"\"]) ~ .media-preview::before,\n.media-preview video[src]:not([src=\"\"]) ~ .media-preview::before {\n  display: none;\n}\n\n/* Fallback for missing images */\n.media-preview img[src=\"\"],\n.media-preview img:not([src]) {\n  background: linear-gradient(135deg, #0f172a 0%, #2563eb 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.media-preview img[src=\"\"]::before,\n.media-preview img:not([src])::before {\n  content: \"📷\";\n  font-size: 2rem;\n  color: white;\n}\n\n.video-preview {\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n\n.video-overlay {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background: rgba(0, 0, 0, 0.7);\n  color: white;\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.5rem;\n}\n\n.media-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n  transition: all 0.3s ease;\n}\n\n.media-item:hover .media-overlay {\n  opacity: 1;\n}\n\n.overlay-actions {\n  display: flex;\n  gap: 15px;\n}\n\n.overlay-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 45px;\n  height: 45px;\n  border: none;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.9);\n  color: #2d3748;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 1.1rem;\n}\n\n.overlay-btn:hover {\n  background: white;\n  transform: scale(1.1);\n}\n\n.selection-indicator {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  width: 30px;\n  height: 30px;\n  background: #0f172a;\n  color: white;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.9rem;\n  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);\n}\n\n.media-info {\n  padding: 20px;\n  background: white;\n}\n\n.media-name {\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: #1a202c !important;\n  margin: 0 0 8px 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  line-height: 1.3;\n}\n\n.media-meta {\n  color: #4a5568 !important;\n  margin: 0 0 10px 0;\n  font-size: 0.95rem;\n  font-weight: 500;\n  line-height: 1.4;\n}\n\n.media-details {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 10px;\n  font-size: 0.85rem;\n  color: #718096 !important;\n  font-weight: 500;\n}\n\n.barcode {\n  background: #e6fffa;\n  color: #234e52 !important;\n  padding: 4px 8px;\n  border-radius: 6px;\n  font-weight: 700;\n  font-size: 0.8rem;\n  border: 1px solid #b2f5ea;\n}\n\n.media-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 5px;\n}\n\n.tag {\n  background: #e6fffa;\n  color: #234e52;\n  padding: 2px 8px;\n  border-radius: 12px;\n  font-size: 0.75rem;\n  font-weight: 500;\n}\n\n/* List View Specific */\n.media-container.list .media-item {\n  display: flex;\n  align-items: center;\n  padding: 15px;\n}\n\n.media-container.list .media-preview {\n  width: 160px;\n  height: 110px;\n  flex-shrink: 0;\n  margin-right: 15px;\n}\n\n.media-container.list .media-info {\n  flex: 1;\n  padding: 0;\n}\n\n.media-container.list .media-name {\n  white-space: normal;\n  margin-bottom: 8px;\n}\n\n/* Empty State */\n.empty-state {\n  text-align: center;\n  padding: 60px 20px;\n  background: white;\n  border-radius: 16px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n  grid-column: 1 / -1;\n}\n\n.empty-icon {\n  font-size: 4rem;\n  color: #a0aec0;\n  margin-bottom: 20px;\n}\n\n.empty-state h3 {\n  font-size: 1.5rem;\n  color: #2d3748;\n  margin: 0 0 10px 0;\n}\n\n.empty-state p {\n  color: #4a5568;\n  margin: 0 0 30px 0;\n}\n\n.upload-first-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: linear-gradient(135deg, #c13183 0%, #4f46e5 100%);\n  color: white;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.upload-first-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.4);\n}\n\n/* Loading State */\n.gallery-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 400px;\n  color: #4a5568;\n}\n\n.loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #e2e8f0;\n  border-top: 4px solid #0f172a;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 20px;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* Upload Modal */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n}\n\n.modal-content {\n  background: white;\n  border-radius: 16px;\n  width: 100%;\n  max-width: 600px;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 25px 30px;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.modal-header h2 {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #2d3748;\n  margin: 0;\n}\n\n.close-btn {\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  color: #a0aec0;\n  cursor: pointer;\n  padding: 5px;\n  border-radius: 6px;\n  transition: all 0.3s ease;\n}\n\n.close-btn:hover {\n  background: #f7fafc;\n  color: #4a5568;\n}\n\n.upload-area {\n  padding: 30px;\n}\n\n.upload-dropzone {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  border: 2px dashed #cbd5e0;\n  border-radius: 12px;\n  background: #f7fafc;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-align: center;\n}\n\n.upload-dropzone:hover {\n  border-color: #0f172a;\n  background: #edf2f7;\n}\n\n.upload-icon {\n  font-size: 3rem;\n  color: #a0aec0;\n  margin-bottom: 20px;\n}\n\n.upload-dropzone h3 {\n  font-size: 1.2rem;\n  color: #2d3748;\n  margin: 0 0 10px 0;\n}\n\n.upload-dropzone p {\n  color: #4a5568;\n  margin: 0;\n}\n\n.upload-progress {\n  margin-top: 20px;\n}\n\n.progress-bar {\n  width: 100%;\n  height: 8px;\n  background: #e2e8f0;\n  border-radius: 4px;\n  overflow: hidden;\n  margin-bottom: 10px;\n}\n\n.progress-fill {\n  height: 100%;\n  background: linear-gradient(135deg, #0f172a 0%, #2563eb 100%);\n  transition: width 0.3s ease;\n}\n\n.upload-options {\n  padding: 0 30px 30px;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n}\n\n.option-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.option-group label {\n  font-weight: 600;\n  color: #2d3748;\n  font-size: 0.9rem;\n}\n\n.option-group select {\n  padding: 10px 15px;\n  border: 2px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 1rem;\n  transition: all 0.3s ease;\n}\n\n.option-group select:focus {\n  outline: none;\n  border-color: #0f172a;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .photo-gallery {\n    padding: 15px;\n  }\n  \n  .gallery-header {\n    flex-direction: column;\n    gap: 15px;\n    align-items: stretch;\n  }\n  \n  .header-left {\n    flex-direction: column;\n    gap: 15px;\n    align-items: stretch;\n  }\n  \n  .page-title h1 {\n    font-size: 1.5rem;\n  }\n  \n  .filters-section {\n    flex-direction: column;\n    gap: 15px;\n  }\n  \n  .filter-groups {\n    width: 100%;\n  }\n  \n  .filter-groups select {\n    width: 100%;\n  }\n  \n  .selection-controls {\n    flex-direction: column;\n    gap: 15px;\n    align-items: stretch;\n  }\n  \n  .selection-actions {\n    justify-content: center;\n    flex-wrap: wrap;\n    gap: 8px;\n  }\n  \n  .action-btns {\n    padding: 10px 16px;\n    font-size: 0.9rem;\n    min-height: 40px;\n    width: 100%;\n  }\n  \n  .action-btns.barcode {\n    min-width: 100px;\n  }\n  \n  .media-container.grid {\n    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n  }\n  \n  .upload-options {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 480px) {\n  .photo-gallery {\n    padding: 10px;\n  }\n  \n  .media-container.grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .modal-content {\n    margin: 10px;\n  }\n  \n  .modal-header,\n  .upload-area {\n    padding: 20px;\n  }\n}\n\n/* === Enhanced Gallery Card UI (non-breaking overrides) === */\n.media-container.grid .media-item {\n  border-radius: 16px;\n  overflow: hidden;\n  background: #fff;\n  border: 1px solid rgba(17, 24, 39, 0.06);\n  box-shadow: 0 8px 24px rgba(17, 24, 39, 0.06);\n  transition: transform 0.25s ease, box-shadow 0.25s ease;\n  display: block; /* Ensure vertical stacking in grid */\n}\n\n.media-container.grid .media-item:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 14px 36px rgba(17, 24, 39, 0.12);\n}\n\n.media-container.grid .media-preview {\n  position: relative;\n  background: #f3f4f6;\n  /* Bigger preview for clarity in grid */\n  aspect-ratio: 16 / 10;\n  width: 50%;\n  height: 50%;\n  /* min-height: 200px; Ensure visibly large preview */\n}\n\n.media-container.grid .media-preview img,\n.media-container.grid .media-preview video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center center;\n  display: block;\n  transition: transform 0.35s ease;\n}\n\n.media-container.grid .media-item:hover .media-preview img,\n.media-container.grid .media-item:hover .media-preview video {\n  transform: scale(1.03);\n}\n\n.media-container.grid .media-overlay {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(to top, rgba(0,0,0,0.45), rgba(0,0,0,0.05));\n  opacity: 0;\n  transition: opacity 0.25s ease;\n}\n\n.media-container.grid .media-item:hover .media-overlay {\n  opacity: 1;\n}\n\n/* Hide overlay buttons in grid minimal mode */\n.media-container.grid .media-overlay.hidden-grid {\n  opacity: 0 !important;\n  pointer-events: none;\n}\n\n/* Name overlay for minimal image-first grid */\n.media-container.grid .name-overlay {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  padding: 10px 12px;\n  background: linear-gradient(to top, rgba(0,0,0,0.65), rgba(0,0,0,0.0));\n  color: #ffffff;\n  font-weight: 700;\n  font-size: 14px;\n  text-shadow: 0 1px 2px rgba(0,0,0,0.35);\n  z-index: 2;\n  display: -webkit-box;\n  line-clamp: 1;\n  -webkit-line-clamp: 1;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.media-container.grid .overlay-actions {\n  position: absolute;\n  bottom: 10px;\n  right: 10px;\n  display: flex;\n  gap: 8px;\n}\n\n.media-container.grid .overlay-btn {\n  width: 36px;\n  height: 36px;\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.9);\n  color: #111827;\n  border: 1px solid rgba(0,0,0,0.06);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  transition: transform 0.15s ease, background 0.2s ease;\n}\n\n.media-container.grid .overlay-btn:hover {\n  transform: translateY(-1px);\n  background: #ffffff;\n}\n\n.media-container.grid .media-info {\n  padding: 12px 14px 14px 14px;\n}\n\n/* Persistent media actions bar */\n.media-actions {\n  display: flex;\n  gap: 8px;\n  padding: 10px 12px 0 12px;\n  background: #ffffff;\n  flex-wrap: wrap;\n}\n\n.media-action-btn {\n  /* width: 50%; */\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 10px 12px;\n  border: 1px solid rgba(17, 24, 39, 0.08);\n  background: #f9fafb;\n  color: #111827;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.2s ease, transform 0.15s ease, color 0.2s ease;\n}\n\n.media-action-btn .label {\n  display: none;\n}\n\n@media (min-width: 520px) {\n  .media-action-btn .label {\n    display: inline;\n  }\n}\n\n.media-action-btn:hover {\n  background: #ffffff;\n  transform: translateY(-1px);\n}\n\n.media-action-btn.view {\n  border-color: rgba(59, 130, 246, 0.25);\n}\n\n.media-action-btn.edit {\n  border-color: rgba(16, 185, 129, 0.25);\n}\n\n.media-action-btn.barcode {\n  border-color: rgba(234, 179, 8, 0.3);\n}\n\n.media-container.grid .media-name {\n  font-weight: 700;\n  color: #111827;\n  margin: 0 0 4px 0;\n  display: -webkit-box;\n  line-clamp: 1;\n  -webkit-line-clamp: 1;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.media-container.grid .media-meta {\n  color: #6b7280;\n  font-size: 12px;\n  margin: 0 0 8px 0;\n  display: -webkit-box;\n  line-clamp: 1;\n  -webkit-line-clamp: 1;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.media-container.grid .media-details {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  color: #6b7280;\n  font-size: 12px;\n}\n\n.media-container.grid .barcode {\n  background: #eef2ff;\n  color: #3730a3;\n  border-radius: 8px;\n  padding: 2px 6px;\n  font-size: 11px;\n}\n\n/* Selection indicator polish */\n.media-container.grid .selection-indicator {\n  position: absolute;\n  top: 10px;\n  left: 10px;\n  width: 26px;\n  height: 26px;\n  border-radius: 50%;\n  background: #2563eb;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.4);\n}\n\n/* Persistent caption under each grid card */\n.media-container.grid .media-caption {\n  padding: 10px 12px 12px 12px;\n  background: #ffffff;\n  border-top: 1px solid rgba(17, 24, 39, 0.06);\n  font-weight: 700;\n  color: #111827;\n  font-size: 14px;\n  line-height: 1.3;\n  display: -webkit-box;\n  line-clamp: 1;\n  -webkit-line-clamp: 1;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
